<template>
	<div>
		<Card>
			<Row :gutter="16">
			    <Col span="24">
			    <div class="global-tool-bar">
			        <div class="left-bar">
			            <span class="title">售价变化统计分析</span>
			            <DatePicker type="daterange"
			                v-model="selectDates"
			                size="small"
			                transfer
			                placement="bottom-end"
			                placeholder="选择期初和期末时间"
			                style=" margin-left:4px;width: 200px"
			                @on-change="onDateChange"></DatePicker>
			            <Select v-model="selectedSeedFarmUuid"
			                style="width:200px;margin-left:5px;"
			                size="small"
			                placeholder="选择苗场"
			                @on-change="onSeedFarmChange"
			                filterable
			                clearable>
			                <Option v-for="item in seedFarmList"
			                    :value="item.seedFarmUuid"
			                    :key="item.seedFarmUuid">{{ item.seedFarmCode + ' '  + item.seedFarmName }}</Option>
			            </Select>
			
			            <Select v-model="selectedProductUuid"
			                style="width:200px;margin-left:5px;"
			                size="small"
			                placeholder="选择商品"
			                filterable
			                clearable>
			                <Option v-for="item in productList"
			                    :key="item.productUuid"
			                    :value="item.productUuid">{{ item.productCode + '-' + item.productName }}</Option>
			            </Select>
			
			            <Button type="success"
			                size="small"
			                class="btns"
			                icon="ios-stats"
			                @click="beginStat()">统计</Button>
						<!-- <Button class="search-btn"
							size="small"
							icon="ios-refresh"
							@click="onReset"
							style="margin-left:10px;">重置</Button> -->
							
			        </div>
			        <div class="right-bar">
			
			        </div>
			    </div>
			    </Col>
			</Row>
			
			<Row :gutter="16">
				<Col span="24">
					<Table ref="mainTable"
						:columns="mainTable.columns"
						size="small"
						:data="mainTable.data"
						:loading="mainTable.loading"
						:height="mainTable.tableHeight"
						stripe
						border />
						
					<Modal v-model="customerStatChangeModal.show"
						:width="1000"
						footer-hide>
						<Spin v-if="customerStatChangeModal.innerSpin"
							size="large"
							fix></Spin>
						<div slot="header">
							<span style="font-weight:bold;font-size: 14px;">售价变化统计</span>
						</div>
						<CustomerStatLine ref="CustomerStatLine"
							style="height: 400px;width:100%;"
							:value="customerStatChangeModal.barData"
							:text="customerStatChangeModal.barTitle" />
					</Modal>
				</Col>
			</Row>
		</Card>
	</div>
</template>

<script>
import search from '@/libs/search';
import StandPaginationTable from '@/components/standard-pagination-table/StandPaginationTable';
import { getOrderPriceAnalyze } from '@/api/modules/stat-analyze/customer-analyze';
import CustomerStatLine from '@/components/charts/customer-stat-line.vue';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { getSeedFarmList } from '@/api/modules/system-management/seedFarm-management';
import { getSeedFarmProductList } from '@/api/modules/system-management/seedFarm-management';
export default{
    name:'customer-order-priceChange',
    components: {
	    StandPaginationTable,
	    CustomerStatLine
    },
    data(){
        return{
            innerSpin:false,
            selectDates: [],
            selectedSeedFarmUuid: '',
            seedFarmList: [],
            productList: [],
            selectedProductUuid: '',
            mainTable:{
                colims:[],
                data:[],
                loading:false,
                tableHeight:100
            },
            customerStatChangeModal:{
                shwo:false,
                innerSpin:false,
                barTitle: '',
                barData: {}
            }
        };
    },
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.getAllSeedFarm();
		
        this.mainTable.tableHeight
		    = window.innerHeight
		    - this.$refs.mainTable.$el.offsetTop
		    - 210;
    },
    methods:{
        getTodayDateString,
        getThisMonthStart,
	    queryStat(postData) {
	        this.mainTable.loading = true;
	        getOrderPriceAnalyze(postData).then(res => {
	            this.mainTable.loading = false;
	            if (res.code === 0) {
	                this.makeNewField();
	                this.mainTable.data = res.data.records;
	            }
	        });
	    },
        makeNewField() {
            this.mainTable.columns = [
                { title: '发货日期', key: 'sendProductDate', width: 120, align: 'center', fixed: 'left' },
                { title: '销售价格', key: 'productPrice', width: 120, align: 'center',
                    renderHeader: (h, { column, index }) => {
						    return h('div',
						        [
						            h('span', {}, column.title),
						            h('icon', {
						                props: {
						                    type: 'md-stats',
						                    size: 18,
						                    color: 'red'
						                },
						                style: {
						                    marginLeft: '8px'
						                },
						                on: {
						                    click: () => {
						                        this.showChart(column);
						                    }
						                }
						
						            })
						        ]
						    );
                    }
                }
            ];
        },
        showChart(column) {
	
            this.customerStatChangeModal.show = true;
            this.customerStatChangeModal.innerSpin = true;
            let barData = {};
            for (let i = 0; i < this.mainTable.data.length - 1; i++) {
                const e = this.mainTable.data[i];
                barData[e['sendProductDate']] = e[column.key];
            }
            this.customerStatChangeModal.barTitle = column.title;
            this.customerStatChangeModal.barData = barData;
            this.customerStatChangeModal.innerSpin = false;
            this.$refs.CustomerStatLine.init();
        },
        getAllSeedFarm() {
		    this.innerSpin = true;
		    let tempSearch = search.getSearchParams({ closeAllConditions: true });
		    getSeedFarmList(tempSearch).then(res => {
		        this.innerSpin = false;
		        if (res.code === 0) {
		            this.seedFarmList = res.data.records;
		        }
		    });
        },
        onSeedFarmChange() {
		    this.innerSpin = true;
		    getSeedFarmProductList({ seedFarmUuid: this.selectedSeedFarmUuid }).then(res => {
		        this.innerSpin = false;
		        if (res.code === 0) {
		            this.productList = res.data.productList;
		        }
		    });
        },
        onDateChange(e) {
		    this.selectDates = e;
        },
        onClickTab(e) {
		    this.$nextTick(() => {
		        this.beginStat();
		    });
        },
        beginStat(){
            let postData = {
			    beginDate: this.selectDates[0],
			    endDate: this.selectDates[1],
			    productUuid: this.selectedProductUuid
            };
            this.queryStat(postData);
        }
        // onReset() {
        //     this.selectedSeedFarmUuid= '';
        // 	this.selectedProductUuid= '';
        // 	this.mainTable.columns=[];
        // 	this.mainTable.data=[];
			
        // }
    }
};
</script>

<style scoped>
</style>